export const STATUS_VERIFIED = "verified";
export const STATUS_IN_PROGRESS = "in_progress";
export const STATUS_NO_ANALYSIS = "no_analysis";
export const STATUS_PENDING = "pending";

export const FOLDER_NEWS_FEED = "news_feed";
export const FOLDER_COLD_CASES = "cold_cases";
export const FOLDER_ARCHIVE = "archive";

export const SOURCE_INSTAGRAM_MESSAGE = "instagram:message";
export const SOURCE_WHATSAPP = "whatsapp";
export const SOURCE_TWITTER_MESSAGE = "twitter:message";
export const SOURCE_TWITTER_MENTION = "twitter:mention";
export const SOURCE_FACEBOOK = "facebook:message";
export const SOURCE_OTHER = "other";

export const ROLE_ADMIN = "1";
export const ROLE_WRITER = "2";
export const ROLE_ENGAGEMENT_EDITOR = "3";
export const ROLE_GUEST = "4";

export class Permissions {
  static READ_USERS = "READ_USERS";
  static EDIT_USERS = "EDIT_USERS";

  static READ_TAGS = "READ_TAGS";
  static EDIT_TAGS = "EDIT_TAGS";

  static READ_CATEGORIES = "READ_CATEGORIES";
  static EDIT_CATEGORIES = "EDIT_CATEGORIES";

  static READ_REPORTS = "READ_REPORTS";
  static EDIT_REPORTS = "EDIT_REPORTS";

  static READ_MAIL_LIST = "READ_MAIL_LIST";
  static EDIT_MAIL_LIST = "EDIT_MAIL_LIST";

  static EDIT_OTHERS_CASE = "EDIT_OTHERS_CASE";
  static SEND_MESSAGE_RESPONSE = "SEND_MESSAGE_RESPONSE";
  static READ_CASES = "READ_CASES";
  static EDIT_CASES = "EDIT_CASES";
  static UPLOAD_FILE = "UPLOAD_FILE";
  static READ_MESSAGES = "READ_MESSAGES";

  static READ_ROLES = "READ_ROLES";
  static READ_NOTIFICATIONS = "READ_NOTIFICATIONS";
  static GET_URL_DETAIL = "GET_URL_DETAIL";
}
export const statusColors = {
  in_progress: "#ff5722",
  pending: "#ff9800",
  no_analysis: "darkslategray",
  verified: "#41B442"
};

export const STARRED_TAG_ID = -1;



// WEBPACK FOOTER //
// ./src/api/constants.tsx